'use strict';

module.exports.format = require('./format');



//////////////////
// WEBPACK FOOTER
// ./src/render/index.js
// module id = 33
// module chunks = 0